<template>
  <app-layout header-type="landing">
    <template #header>
      <div>
        <h1 class="text-3xl md:text-4xl font-light">
          {{ state.title }}
        </h1>
      </div>
    </template>
    <div
      v-if="state.content"
      class="container max-w-lg content"
      v-html="parseMarkdown(state.content, false)"
    />
    <component
      :is="state.page"
      v-else
    />
  </app-layout>
</template>

<script>
export default {
  name: "AppPage",
  created() {
    document.title = `${this.state.title} :: ${document.title}`;
  }
};
</script>
